import { isPlatformBrowser } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchPipe'
})
export class SearchPipePipe implements PipeTransform {

  transform(items: any[], ...args: any[]): any {
    const search: string = (args[0] as string).toLowerCase().trim();
    const searchFields: string[] = args[1];

    if (search == null || search.length == 0) {
      return items;
    }

    return items.filter(s => searchFields.filter(f => s[f] != null && s[f].toLowerCase().indexOf(search) > -1).length > 0);
  }

}
